// `ch` resolves against the element's own font size: without `text-body-1` here, 54ch inherits
// the body's 16px and comes out a fifth too narrow.
export const MEASURE = "text-body-1 max-w-[54ch]";

export const ANCHOR = "scroll-mt-[96px]";

export const INLINE =
  "[&_strong]:font-semibold [&_em]:not-italic [&_em]:font-semibold [&_a]:text-primary-800 [&_a]:underline [&_a]:underline-offset-[3px] [&_a]:decoration-primary-800/40 [&_a:hover]:text-primary-825 [&_a:hover]:decoration-primary-825 [&_a]:transition-colors";

export const NESTED =
  "[&_ul]:list-disc [&_ol]:list-decimal [&_ul]:pl-3s [&_ol]:pl-3s [&_ul]:mt-2xs [&_ol]:mt-2xs [&_li+li]:mt-3xs [&_li]:marker:text-neutral-150 [&_ul>li]:marker:text-primary-800[&_p+p]:mt-2xs [&_p+ul]:mt-2xs [&_p+ol]:mt-2xs [&_ul+p]:mt-2xs [&_ol+p]:mt-2xs [&_p]:m-none";

export const LABEL = "text-title-1 font-semibold text-neutral-425 m-none";
export const HEADLINE = "text-body-1 font-semibold text-neutral-675 m-none";
export const ACTION = "text-button-2 font-semibold";

export const CARD = "bg-neutral-12 rounded-m";
